import { useDispatch } from "react-redux";
import {
  fetchConveyorBox,
  finishSkuPutaway,
  setBoxAsControlled,
  triggerBatchPick,
  triggerPostPick,
  updateBoxBarcode,
  relocateBox,
  requestNewShippingLabel,
  changeLabelInAutomation,
  printNewLabel
} from "../lib/store/reducers/conveyorBoxReviewReducer";
import { PayloadWrapper } from "../lib/store/types/PayloadWrapper";
import {
  setIsChangeWeightModalOpen,
  setIsPartialDeliveryModalOpen,
  setIsSwapBoxModalOpen,
} from "../lib/store/reducers/controlAppStateReducer";
import Constants from "../lib/aframeboxlookup/Constants";

const { LookupValueOrigin } = Constants;

const useConveyorBoxHandlers = () => {
  const dispatch = useDispatch();

  const onPostPickHandler = () => dispatch(triggerPostPick());
  const onBatchPickHandler = () => dispatch(triggerBatchPick());
  const onOpenPartialDeliveryModalHandler = () =>
    dispatch(setIsPartialDeliveryModalOpen(new PayloadWrapper(true)));
  const onFetchConveyorBoxHandler = (value: string) =>
    dispatch(
      fetchConveyorBox({
        type: LookupValueOrigin.ScannedBarcode,
        input: value.trim().toUpperCase(),
      })
    );
  const onTriggerBoxSwapHandler = (currentBarcode: string, newBarcode: string, selectedBoxSize: string) =>
    dispatch(updateBoxBarcode({ currentBarcode, newBarcode, selectedBoxSize }));
  const onFinishSkuPutawayHandler = (items: any) => {
    dispatch(finishSkuPutaway(new PayloadWrapper(items)));
  };
  const onClosePartialDeliveryModalHandler = () =>
    dispatch(setIsPartialDeliveryModalOpen(new PayloadWrapper(false)));
  const onSetBoxAsControlledHandler = () => dispatch(setBoxAsControlled());
  const onOpenSwapBoxModalHandler = () => dispatch(setIsSwapBoxModalOpen(new PayloadWrapper(true)));
  const onRequestNewShippingLabelHandler: any = () => dispatch(requestNewShippingLabel());
  const onPrintNewLabelHandler: any = () => dispatch(printNewLabel());
  const onChangeLabelInAutomationHandler: any = () => dispatch(changeLabelInAutomation());
  const onRelocateBoxHandler = () => dispatch(relocateBox());
  const onOpenChangeWeightHandler = () => dispatch(setIsChangeWeightModalOpen(new PayloadWrapper(true)));

  return {
    onPostPickHandler,
    onBatchPickHandler,
    onOpenPartialDeliveryModalHandler,
    onOpenChangeWeightHandler,
    onFetchConveyorBoxHandler,
    onTriggerBoxSwapHandler,
    onFinishSkuPutawayHandler,
    onClosePartialDeliveryModalHandler,
    onSetBoxAsControlledHandler,
    onOpenSwapBoxModalHandler,
    onRequestNewShippingLabelHandler,
    onChangeLabelInAutomationHandler,
    onPrintNewLabelHandler,
    onRelocateBoxHandler,
  };
};

export default useConveyorBoxHandlers;
